module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.sendMessage
    }
  }, [_vm._v(_vm._s(_vm.val))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cff2ae9a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/component/backTime.vue
// module id = 163
// module chunks = 2